import { useCallback, useContext } from "react";
import type { NRErrorInfo } from "@swiggy-private/js-utils";
import { SwiggyContextHeader } from "@swiggy-private/portal-dineout-context";
import { sendCustomNREvViaBlaze } from "utils/newrelic";
import { NR_TABLES } from "../constants";

export const usePLError = (page: string) => {
    const { swiggyHeaders } = useContext(SwiggyContextHeader);

    const onWidgetError = useCallback(
        (error: NRErrorInfo, widgetName?: string) => {
            sendCustomNREvViaBlaze(
                NR_TABLES.STATIC_PAGE_PL_WIDGET_ERROR,
                {
                    ...error,
                    widgetName: widgetName || "",
                    url: window?.location?.href || "",
                    page,
                },
                swiggyHeaders ?? {},
            );
        },
        [page, swiggyHeaders],
    );

    const onInvalidWidget = useCallback(
        (widgetName?: string) => {
            sendCustomNREvViaBlaze(
                NR_TABLES.STATIC_PAGE_PL_WIDGET_INVALID,
                {
                    widgetName: widgetName || "",
                    url: window?.location?.href || "",
                    page,
                },
                swiggyHeaders ?? {},
            );
        },
        [page, swiggyHeaders],
    );

    const onEmptyPage = useCallback(() => {
        sendCustomNREvViaBlaze(
            NR_TABLES.STATIC_PAGE_PL_WIDGET_EMPTY,
            {
                url: window?.location?.href || "",
                page,
            },
            swiggyHeaders ?? {},
        );
    }, [page, swiggyHeaders]);

    return { onWidgetError, onInvalidWidget, onEmptyPage };
};
